
export default {
  props: { store: { type: Object, default: () => {} } },
};
